import { Hub } from 'aws-amplify/utils';
import { useResetApp } from '../components/ResetAppProvider';
import { useEffect } from 'react';
import { signInWithRedirect } from 'aws-amplify/auth';

export type SignInWithRedirect = (provider: 'Apple' | 'Google' | { custom: 'CorporateSSO' }) => void;

export type UseFederatedAuthReturnValue = {
    signInWithRedirect: SignInWithRedirect;
};

export const useFederatedAuth = (): UseFederatedAuthReturnValue => {
    const resetApp = useResetApp();

    useEffect(() => {
        const unsubscribe = Hub.listen('auth', ({ payload: { event } }) => {
            switch (event) {
                case 'signInWithRedirect':
                case 'signedIn':
                    resetApp();
                    break;
            }
        });

        return unsubscribe;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        signInWithRedirect: (provider) => {
            signInWithRedirect({
                provider,
            });
        },
    };
};
